import React from "react";
import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  image?: string;
  url?: string;
  jsonLd?: object;
}

const defaultBusiness = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "Mobile Detail Co",
  image: "https://mobiledetailco.com/og-image.png",
  url: window?.location?.href || "https://mobiledetailco.com",
  description: "Premium mobile auto detailing services in Minneapolis, St. Paul and surrounding suburbs.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "1008 Fairfield Spur",
    addressLocality: "Hopkins",
    addressRegion: "MN",
    postalCode: "55305",
    addressCountry: "US"
  },
  telephone: ""
};

export function SEO({ title, description, image, url, jsonLd }: SEOProps) {
  const canonical = url || window?.location?.href || "https://mobiledetailco.com";
  const defaultJsonLd = {
    ...defaultBusiness,
    title,
    description,
    image: image || defaultBusiness.image,
    url: canonical,
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      {image && <meta property="og:image" content={image} />}
      <meta property="og:type" content="website" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}

      {/* Default JSON-LD structured data for business */}
      <script type="application/ld+json">
        {JSON.stringify(defaultJsonLd)}
      </script>
      {/* Page-specific JSON-LD if provided */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
} 